// implement moveCursorToEnd, selectAllContent, they accept HTMLElement as parameter
export function moveCursorToEnd(el: HTMLElement) {
    if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
        const len = el.value.length;
        el.setSelectionRange(len, len);
        el.focus();
    }
}

export function selectAllContent(el: HTMLElement) {
    if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
        el.select();
    }
}

